import { INCENTIVE_FIELDS } from 'consts/storageConsts';
import { URGENCY_OFFER_COHORT_REWARD_AMOUNTS } from 'consts/urgencyOfferConsts';

import { getValueFromStorage } from 'utils/storage/storageHelper';

const incentiveFields = getValueFromStorage(INCENTIVE_FIELDS);
export const decodedCohort = incentiveFields?.incentive_cohort_name
  ? atob(incentiveFields.incentive_cohort_name)
  : '';

export const urgencyOfferDecodedTTL = incentiveFields?.receiver_incentive_ttl
  ? parseInt(atob(incentiveFields.receiver_incentive_ttl))
  : 0;
export const urgencyOfferAmount =
  URGENCY_OFFER_COHORT_REWARD_AMOUNTS[decodedCohort] || 0;

// This is a check to render Urgency Offer Content, specifically for a case when referee is eligible for incentive
export const showUrgencyOfferContent =
  urgencyOfferAmount != 0 && urgencyOfferDecodedTTL != 0;
